export enum CACertificateItemType {
  CERTIFICATE = "CERTIFICATE",
  CSR = "CSR",
  TRUSTCHAIN = "TRUSTCHAIN",
}
